



























import * as Vue from '@vue/composition-api'
import AuthApi from '@/ts/apis/AuthApi'

const MSG_NEED_LOGIN = 'オーダーするにはTwitterでログインしてください'
const MSG_LOGIN_CHECK = 'ログイン状態を確認しています。しばらくお待ちください...'
const MSG_ORDER_INPROG = 'オーダー処理中...'
const MSG_ORDER_COMPLETED = 'オーダーを完了しました'
const MSG_ORDER_ERROR = 'オーダーできませんでした。トップ画面から再度オーダーを試してみてください'

type orderState = 'default' | 'login' | 'inprog' | 'completed' | 'error'

const STATE_MSGS: { [key in orderState]: string } = {
  default: MSG_NEED_LOGIN,
  login: MSG_LOGIN_CHECK,
  inprog: MSG_ORDER_INPROG,
  completed: MSG_ORDER_COMPLETED,
  error: MSG_ORDER_ERROR
}

const newDataObj = (): {
    hasError: boolean,
    orderCompleted: boolean,
    orderState: orderState
  } => ({
  hasError: false,
  orderCompleted: false,
  orderState: 'default'
})

export default Vue.createComponent({
  name: 'OrderPage',
  props: {
    docId: String,
    itemType: String
  },
  setup (props, ctx) {
    const data = Vue.reactive(newDataObj())
    const isSnsLoggedin = Vue.computed(() => {
      return ctx.root.$store.state.user.authorized
    })
    const stateMsg = Vue.computed(() => {
      return STATE_MSGS[data.orderState]
    })

    const snsLogin = () => {
      data.orderState = 'login'
      ctx.root.$store.dispatch('user/snsLinkup')
    }

    const goTop = () => {
      ctx.root.$store.dispatch('doc/closeDoc')
      ctx.root.$store.dispatch('doc/listDocs')
      ctx.root.$router.push('/')
    }

    const order = async () => {
      if (data.orderState !== 'default' && data.orderState !== 'login') {
        console.log('スキップ: ', data.orderState)
        return
      }
      data.orderState = 'inprog'
      const isCompleted = await ctx.root.$store.dispatch('doc/orderDoc', { id: props.docId, itemType: props.itemType })
      data.orderState = isCompleted ? 'completed' : 'error'
      console.log('オーダー完了: ', data.orderState)
    }

    Vue.watch(() => isSnsLoggedin.value, async () => {
      if (!isSnsLoggedin.value) {
        return
      }
      await order()
    })

    Vue.onBeforeMount(async () => {
      if (!ctx.root.$store.state.doc.docId) {
        console.log('state', data.orderState)
        data.orderState = 'login'
      }
      const user = await AuthApi.getUser()
      if (ctx.root.$store.state.user.authorized) {
        await order()
      }
    })

    return {
      data,
      stateMsg,
      isSnsLoggedin,
      snsLogin,
      goTop
    }
  }
})
